<template>
  <div class="modal-card" :style="{ width: width || '960px' }">
    <div class="modal-card-head">
      <p class="modal-card-title">{{title}}</p>
      <button type="button" class="delete" @click="$emit('close')" />
    </div>
    <div class="modal-card-body">
      <configurator-modal-modem v-if="content === 'modem'" />
      <configurator-modal-sdwan v-if="content === 'sdwan'" />
      <configurator-modal-case v-if="content === 'case'" />
      <configurator-modal-accessories v-if="content === 'accessories'" />
      <configurator-modal-warranty v-if="content === 'warranty'" />
      <configurator-modal-connectivity v-if="content === 'connectivity'" />
      <configurator-modal-market-commercial v-if="content === 'market-commercial'" />
      <configurator-modal-market-government v-if="content === 'market-government'" />
      <configurator-modal-market-military v-if="content === 'market-military'" />
    </div>
  </div>
</template>
<script>
import ConfiguratorModalModem from './ConfiguratorModalModem.vue';
import ConfiguratorModalSdwan from './ConfiguratorModalSdwan.vue';
import ConfiguratorModalCase from './ConfiguratorModalCase.vue';
import ConfiguratorModalAccessories from './ConfiguratorModalAccessories.vue';
import ConfiguratorModalWarranty from './ConfiguratorModalWarranty.vue';
import ConfiguratorModalConnectivity from './ConfiguratorModalConnectivity.vue';
import ConfiguratorModalMarketCommercial from './market/ConfiguratorModalMarketCommercial.vue';
import ConfiguratorModalMarketGovernment from './market/ConfiguratorModalMarketGovernment.vue';
import ConfiguratorModalMarketMilitary from './market/ConfiguratorModalMarketMilitary.vue';

export default {
  components: { 
    ConfiguratorModalModem, 
    ConfiguratorModalSdwan, 
    ConfiguratorModalCase, 
    ConfiguratorModalAccessories, 
    ConfiguratorModalWarranty,
    ConfiguratorModalConnectivity,
    ConfiguratorModalMarketCommercial,
    ConfiguratorModalMarketGovernment,
    ConfiguratorModalMarketMilitary
  },
  props: ['content', 'title', 'width'],
  setup() {
    return {
      ConfiguratorModalModem,
      ConfiguratorModalSdwan,
      ConfiguratorModalCase,
      ConfiguratorModalAccessories,
      ConfiguratorModalWarranty,
      ConfiguratorModalConnectivity,
      ConfiguratorModalMarketCommercial,
      ConfiguratorModalMarketGovernment,
      ConfiguratorModalMarketMilitary
    }
  }
}
</script>
